import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Confirmation.css'; // Ensure this file is created

const Confirmation = ({ message }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect after 3 seconds
    const timer = setTimeout(() => {
      navigate('/'); // Redirect to a thank-you page or home page
    }, 3000);

    // Cleanup the timer
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="confirmation-container">
      <div className="confirmation-box">
        <h2>Success!</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Confirmation;
